export class HistoryWrapper {
    static history;
    static init(history){
        HistoryWrapper.history = history;
    }
}
